import Spline from 'cubic-spline';

const screenWidth = [320, 360, 750, 1024, 1280, 1800];

const circleDimensions = [1170, 1319, 1843, 1583, 1583, 2223];

const leftMeasurements = {
  all: [1.15, 1.1, 1.3, 2, 1.65, 1.65],
  single: [2, 2.1, 2.3, 5, 4.5, 4.5],
  footer: [1.8, 1.8, 1.5, 2.2, 2.75, 2.75]
};

const topMeasurements = {
  all: [6, 6, 6, 20, 20, 20],
  single: [6, 6, 6, 6, 6, 6]
};

const bottomMeasurements = [2.3, 2.2, 1.5, 1.7, 1.6, 1.4];

// Based on Sketch file
// Width of circle at certain breakpoint
const widthSpline = new Spline(circleDimensions, screenWidth);

const leftSpline = {
  all: new Spline(leftMeasurements.all, screenWidth),
  single: new Spline(leftMeasurements.single, screenWidth),
  footer: new Spline(leftMeasurements.footer, screenWidth)
};

const topSpline = {
  all: new Spline(topMeasurements.all, screenWidth),
  single: new Spline(topMeasurements.single, screenWidth)
};

const bottomSpline = new Spline(bottomMeasurements, screenWidth);

const closest = (arr, goal) =>
  arr.reduce((prev, curr) =>
    Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev
  );

export const getCircleDimensions = (pageWidth, type) => {
  const circleWidth = widthSpline.at(pageWidth);
  const closestWidth = closest(screenWidth, pageWidth);

  const size = Math.round(
    (circleWidth[0] && circleWidth[0][0]) ||
      circleDimensions[screenWidth.findIndex(elem => elem === closestWidth)]
  );

  const leftOffset = leftSpline[type].at(pageWidth);
  const leftFactor =
    (leftOffset.length > 0 && leftOffset[0][0]) ||
    leftMeasurements[type][
      screenWidth.findIndex(elem => elem === closestWidth)
    ];

  const left = Math.round(size / leftFactor);

  if (type === 'footer') {
    const bottomOffset = bottomSpline.at(pageWidth);
    const bottomFactor =
      (bottomOffset.length > 0 && bottomOffset[0][0]) ||
      bottomMeasurements[screenWidth.findIndex(elem => elem === closestWidth)];

    const bottom = Math.round(size / bottomFactor);

    return { size, left: `-${left}px`, bottom: `-${bottom}px` };
  } else {
    const topOffset = topSpline[type].at(pageWidth);
    const topFactor =
      (topOffset.length > 0 && topOffset[0][0]) ||
      topMeasurements[type][
        screenWidth.findIndex(elem => elem === closestWidth)
      ];

    const top = Math.round(size / topFactor);

    return { size, left: `-${left}px`, top: `-${top}px` };
  }
};
